import React, { useEffect, useState } from "react";
import "./HealthInsuranceTable.css";
import axios from "axios";
import { Table, Spin, Form, Input, Popconfirm, Typography, Button } from "antd";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, JsonConfig, FormConfig, UserName, jwtToken } from "../../Repository/BaseRepository";
import { callGetGridData, prepareCSV } from "../../Repository/HealthInsuranceRepository";
import { EditFilled, CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";

const HealthInsuranceTable = (props) => {
    const propsData = props.gridData;
    const [gridData, setGridData] = useState([]);
    const tableSpin = props.tableSpin;
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [prepareCSVSpin, setPrepareCSVSpin] = useState(false)
    const [searchRow, setSearchRow] = useState("")
    const pageSize = 5;
    const date = new Date();
    var todayDate = parseInt(date.getMonth() + 1) + '/' + parseInt(date.getDate()) + '/' + parseInt(date.getFullYear());
    useEffect(() => {
        setGridData(propsData)
    }, [propsData])
    const isEditing = (record) => record.Id === editingKey;
    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                required: true,
                                message: `Please Input ${title}!`,
                            },
                        ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.File)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.SSN)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Full_Name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });

    const columns = [
        {
            title: 'Division',
            dataIndex: 'Division',
            key: 'Division',
            editable: true
        },
        {
            title: 'Corp W2',
            dataIndex: 'Corp_W2',
            key: 'Corp_W2',
            editable: true
        },
        {
            title: 'SSN',
            dataIndex: 'SSN',
            key: 'SSN',
            editable: true,
            // fixed: "left"
        },
        {
            title: 'File',
            dataIndex: 'File',
            key: 'File',
            editable: true,
            // fixed: "left",
            ...filterProps(),
        },
        {
            title: 'Full Name',
            dataIndex: 'Full_Name',
            key: 'Full_Name',
            editable: true
        },
        {
            title: 'Frequency',
            dataIndex: 'Freq',
            key: 'Freq',
            editable: true
        },
        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'Status',
            editable: true
        },
        {
            title: 'Code',
            dataIndex: 'Code',
            key: 'Code',
            editable: true
        },
        {
            title: 'ER Cost',
            dataIndex: 'ER_Cost',
            key: 'ER_Cost',
            editable: true
        },
        {
            title: 'Effective Date',
            dataIndex: 'Effective_Date',
            key: 'Effective_Date',
            editable: true
        },
        {
            title: 'EE PreTax',
            dataIndex: 'EE_PreTax',
            key: 'EE_PreTax',
            editable: true
        },
        {
            title: 'EE PostTax',
            dataIndex: 'EE_PostTax',
            key: 'EE_PostTax',
            editable: true
        },
        {
            title: 'Payroll Code',
            dataIndex: 'Payroll_Code',
            key: 'Payroll_Code',
            editable: true
        },
        {
            title: 'Total Cost',
            dataIndex: 'Total_Cost',
            key: 'Total_Cost',
            editable: true
        },
        {
            title: 'Per Day',
            dataIndex: 'Per_Day',
            key: 'Per_Day',
            editable: true
        },
        {
            title: todayDate,
            dataIndex: 'NewEmployeeData',
            key: 'NewEmployeeData',
            editable: true
        },
        {
            title: 'Employee Status',
            dataIndex: 'Employee_Status',
            key: 'Employee_Status',
            editable: true
        },
        {
            title: 'Pay Cycle',
            dataIndex: 'Pay_Cycle',
            key: 'Pay_Cycle',
            editable: true
        },
        {
            title: 'Plan Admin Name',
            dataIndex: 'Plan_Admin_Name',
            key: 'Plan_Admin_Name',
            editable: true
        },
        {
            title: 'Plan Type',
            dataIndex: 'Plan_Type',
            key: 'Plan_Type',
            editable: true
        },
        {
            title: 'Term Date',
            dataIndex: 'TermDate',
            key: 'TermDate',
            editable: true
        },
        {
            title: 'Action',
            dataIndex: 'operation',
            width: 150,
            fixed: "right",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editHRTableRowData(record)} onCancel={cancel}>
                            <Typography.Link style={{ marginRight: 8, }}>
                                <CheckCircleFilled style={{ fontSize: 19, color: 'green' }} className="save-cancel-icon" />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseCircleFilled style={{ fontSize: 19, color: 'red' }} className="save-cancel-icon" />
                        </Typography.Link>
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        <div>
                            <EditFilled style={{ fontSize: 18, color: '#003A8C' }} />
                        </div>
                    </Typography.Link>
                );
            },
        },
    ]
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const editHRTableRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            const data = {
                "id": currentRowData.Id,
                "division": currentRowData.Division,
                "corp_W2": currentRowData.Corp_W2,
                "ssn": currentRowData.SSN,
                "file": currentRowData.File,
                "full_Name": currentRowData.Full_Name,
                "freq": currentRowData.Freq,
                "status": currentRowData.Status,
                "employee_Status": currentRowData.Employee_Status,
                "termDate": currentRowData.TermDate,
                "plan_Type": currentRowData.Plan_Type,
                "plan_Admin_Name": currentRowData.Plan_Admin_Name,
                "code": currentRowData.Code,
                "eR_Cost": currentRowData.ER_Cost,
                "effective_Date": currentRowData.Effective_Date,
                "pay_Cycle": currentRowData.Pay_Cycle,
                "eE_PreTax": currentRowData.EE_PreTax,
                "eE_PostTax": currentRowData.EE_PostTax,
                "payroll_Code": currentRowData.Payroll_Code,
                "total_Cost": currentRowData.Total_Cost,
                "per_Day": currentRowData.Per_Day,
                "upload_Date": currentRowData.upload_Date,
                "newEmployeeData": currentRowData.NewEmployeeData
            }
            let url = `${BaseUrl}HealthInsurance/updatingGridData`;
            const response = await axios.put(url, data, JsonConfig)
            if (response.data.statusCode === 200) {
                const res = await callGetGridData()
                if (res !== null) {
                    setGridData(res)
                    SuccessMessage(response.data.message)
                }
            }
            else if (response.data.statusCode === 500) {
                InfoMessage(response.data.message)
            }
            setEditingKey("");
        }
        catch {
            ErrorMessage("Can't able update data")
            setEditingKey("");
        }

    }
    const cancel = () => {
        setEditingKey('');
    };
    const edit = (record) => {
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.Id);
    };
    const callPrepareCSV = async () => {
        setPrepareCSVSpin(true)
        const resp = await prepareCSV(gridData)
        if (resp === "downloaded") {
            SuccessMessage("Downloaded successfully !!")
        }
        setPrepareCSVSpin(false)
    }

    return (<>
        <div className={gridData.length > 0 ? "hrtable-row" : "hrtable-row-minimized"}>
            <div className="search-row">
                <Input
                    placeholder="Search File Number \ SSN \ Name"
                    className="hr-searchrow"
                    style={{ borderColor: "#002766", color: "#F4F9FF" }}
                    onChange={(e) => setSearchRow(e.target.value)}
                    allowClear
                    suffix={
                        <SearchOutlined
                            style={{ color: "#002766", justifyContent: "space-between" }}
                        />
                    }
                />
            </div>
            <div>
                {
                    tableSpin ? <Spin tip="Loading..."> <Form form={form} component={false}>
                        <Table rowClassName="editable-row"
                            className="hrfile-table"
                            columns={mergedColumns} dataSource={gridData}
                            components={{ body: { cell: EditableCell, }, }} scroll={{ x: "max-content" }}
                            pagination={{ pageSize, position: ['bottomCenter'] }}
                        ></Table>
                    </Form> </Spin> : <Form form={form} component={false}>
                        <Table rowClassName="editable-row"
                            className="hrfile-table"
                            columns={mergedColumns} dataSource={gridData}
                            components={{ body: { cell: EditableCell, }, }} scroll={{ x: "max-content" }}
                            pagination={{ pageSize, position: ['bottomCenter'] }}
                        ></Table>
                    </Form>
                }
            </div>
            <div className={gridData.length > 0 ? "validate-prepare-row" : "validate-prepare-row-minimized"}>
                <Button className="prepare-csv-button" onClick={callPrepareCSV} loading={prepareCSVSpin}>Prepare CSV</Button>
            </div>

        </div>
    </>)

}
export default HealthInsuranceTable;